import TileJSONClass, * as TileJSONModule from './../../node_modules/ol/source/TileJSON.js';

class TileJSON extends TileJSONClass {
    constructor(options = {}) {
        options = options || {}
        super(options);
    }
}

// Copy all named exports as static methods
for (const key in TileJSONModule) {
    if (key !== "default") {
        TileJSON[key] = TileJSONModule[key];
    }
}

export default TileJSON;

// Re-export ALL named exports from OL
export * from './../../node_modules/ol/source/TileJSON.js';